// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  html{
 /* width:fit-content; */
 height: 100vh;
  }
}

@media print {
  .registration-success {
    display: none !important; /* Hide success notification when printing */
  }

  .grid-success-view {
    display: none !important; 
  }

  .typography-subtitle-success {
    display: none !important; 
  }

  /* Hide interactive elements and unnecessary components */
  button, a, .MuiButton-root {
    display: none !important; /* Remove buttons and links */
  }

  /* Reset margins and padding for body and html */
  body, html {
    margin: 0;
    padding: 0;
    height: auto;
    overflow: visible;
  }

  /* Adjust the container to avoid skipping pages */
  .MuiBox-root {
    margin: 0 !important;
    padding: 0 !important;
    page-break-before: auto; /* Avoid unnecessary page breaks */
    page-break-after: auto;
  }

  /* Prevent page breaks inside grid or details content */
  .MuiGrid-container, .Details, .Box {
    page-break-inside: avoid;
  }

  /* Reduce unnecessary spacing in the typography */
  .MuiTypography-root {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.2 !important;
  }

  /* Ensure that heading sizes are small enough to fit */
  h1, h2, h3, h4 {
    font-size: 1.25em !important;
    margin: 10px 0 !important;
  }

  /* Specific for the first section to make sure it starts on the first page */
  .first-section {
    margin-top: 0 !important;
    padding-top: 0 !important;
    page-break-before: auto;
  }

  /* General content adjustments to fit everything on the first page */
  * {
    font-size: 12px !important;
    line-height: 1.2 !important;
  }

  /* Prevent unnecessary page breaks in key sections */
  #personalData, .Details {
    page-break-inside: avoid;
    page-break-before: auto;
    page-break-after: auto;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;CACD,uBAAuB;CACvB,aAAa;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB,EAAE,4CAA4C;EACxE;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,yDAAyD;EACzD;IACE,wBAAwB,EAAE,6BAA6B;EACzD;;EAEA,gDAAgD;EAChD;IACE,SAAS;IACT,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;;EAEA,iDAAiD;EACjD;IACE,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB,EAAE,kCAAkC;IAC3D,sBAAsB;EACxB;;EAEA,uDAAuD;EACvD;IACE,wBAAwB;EAC1B;;EAEA,iDAAiD;EACjD;IACE,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA,sDAAsD;EACtD;IACE,4BAA4B;IAC5B,yBAAyB;EAC3B;;EAEA,4EAA4E;EAC5E;IACE,wBAAwB;IACxB,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA,oEAAoE;EACpE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,oDAAoD;EACpD;IACE,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  html{\r\n /* width:fit-content; */\r\n height: 100vh;\r\n  }\r\n}\r\n\r\n@media print {\r\n  .registration-success {\r\n    display: none !important; /* Hide success notification when printing */\r\n  }\r\n\r\n  .grid-success-view {\r\n    display: none !important; \r\n  }\r\n\r\n  .typography-subtitle-success {\r\n    display: none !important; \r\n  }\r\n\r\n  /* Hide interactive elements and unnecessary components */\r\n  button, a, .MuiButton-root {\r\n    display: none !important; /* Remove buttons and links */\r\n  }\r\n\r\n  /* Reset margins and padding for body and html */\r\n  body, html {\r\n    margin: 0;\r\n    padding: 0;\r\n    height: auto;\r\n    overflow: visible;\r\n  }\r\n\r\n  /* Adjust the container to avoid skipping pages */\r\n  .MuiBox-root {\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n    page-break-before: auto; /* Avoid unnecessary page breaks */\r\n    page-break-after: auto;\r\n  }\r\n\r\n  /* Prevent page breaks inside grid or details content */\r\n  .MuiGrid-container, .Details, .Box {\r\n    page-break-inside: avoid;\r\n  }\r\n\r\n  /* Reduce unnecessary spacing in the typography */\r\n  .MuiTypography-root {\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n    line-height: 1.2 !important;\r\n  }\r\n\r\n  /* Ensure that heading sizes are small enough to fit */\r\n  h1, h2, h3, h4 {\r\n    font-size: 1.25em !important;\r\n    margin: 10px 0 !important;\r\n  }\r\n\r\n  /* Specific for the first section to make sure it starts on the first page */\r\n  .first-section {\r\n    margin-top: 0 !important;\r\n    padding-top: 0 !important;\r\n    page-break-before: auto;\r\n  }\r\n\r\n  /* General content adjustments to fit everything on the first page */\r\n  * {\r\n    font-size: 12px !important;\r\n    line-height: 1.2 !important;\r\n  }\r\n\r\n  /* Prevent unnecessary page breaks in key sections */\r\n  #personalData, .Details {\r\n    page-break-inside: avoid;\r\n    page-break-before: auto;\r\n    page-break-after: auto;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
